/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const ResultState = {
    Accepted: 'Accepted',
    Ignored: 'Ignored',
    Discarded: 'Discarded'
} as const;
export type ResultState = typeof ResultState[keyof typeof ResultState];


export function ResultStateFromJSON(json: any): ResultState {
    return ResultStateFromJSONTyped(json, false);
}

export function ResultStateFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResultState {
    return json as ResultState;
}

export function ResultStateToJSON(value?: ResultState | null): any {
    return value as any;
}

/**
 * Check if a given object implements the ResultState interface.
 */
 export function instanceOfResultState(value: any): value is ResultState {
    return Object.values(ResultState).includes(value)
}

